<form name="form" class="page-fix-accessibility-form" #form="ngForm">
    <page-fix-form-wizard-container (dismiss)="dismiss.emit()"
                                    (close)="closeModal($event.pageFix)"
                                    [formValid]="!!form.valid && customValidation"
                                    [pageFixApplied]="!!pageFix"
                                    [pageFix]="pageFix">
        <page-fix-form-info-view [monType]="infoViewType"
                                 [monSelected]="!pageFix"
                                 [monOrder]="0">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/blink.png"
                     [attr.alt]="'Blink sample image' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Why shouldn't I use the blink element?</h2>
                <p translate>
                    Blink is an element that creates a blinking effect for text.
                    Avoiding its use is highly recommended however, as most browsers consider it obsolete.
                    Any kind of blinking content is a bad practise in terms of accessibility, as it can trigger seizures for certain users.
                </p>
                <h3 translate>And how are we going to fix it?</h3>
                <p translate>
                    Since blink tags are obsolete they need to be replaced.
                    In the options card choose a tag you wish to use on your website instead.
                </p>
            </txt-slot>
        </page-fix-form-info-view>
        <page-fix-form-blink-options [monPageFix]="pageFix"
                                     [monPageFixId]="pageFixId"
                                     [monPageFixSelector]="pageFixSelector"
                                     [monType]="optionsViewType"
                                     [monSelected]="!!pageFix"
                                     [monOrder]="1">
        </page-fix-form-blink-options>
        <page-fix-form-info-view [monType]="testingViewType" [monOrder]="2">
            <img-slot>
                <img class="img-responsive image-sample inline-block"
                     src="/images/page-fix/design/blink-test.png"
                     [attr.alt]="'Blink testing sample image' | translate"/>
            </img-slot>
            <txt-slot>
                <h2 translate>Potential problems that can arise</h2>
                <p translate>
                    The chances that a blink tag even exists in your website are quite low, as it is a tag that is no longer relevant.
                    However, if you notice some styling changes that you do not like on your website where there used to be some blink tags, try changing them into a different tag (in options).
                </p>
            </txt-slot>
        </page-fix-form-info-view>
    </page-fix-form-wizard-container>
</form>
